import { RulesApiFactory } from "@/apis/research/rules";
import { apiRuleToRuleDraft } from "@/components/ai-consumer-research/brand-moderator/rules/api-rule-to-draft";
import { RuleBuilderPage } from "@/components/ai-consumer-research/brand-moderator/rules/rule-builder-page";
import { Skeleton } from "@/components/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";
import { useMemo } from "react";
import { ChevronLeft } from "lucide-react";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/rules/update/$id")({
  validateSearch: z.object({
    template: z.string().optional(),
  }),
  component: UpdateRule,
});

function UpdateRule() {
  const { id } = Route.useParams();
  const { data: ruleResponse, isLoading } = useQuery(RulesApiFactory.Queries.GetRuleById(id));
  const { template } = Route.useSearch();

  const initialRuleDraft = useMemo(() => {
    const rule = ruleResponse?.data;
    if (!rule) return undefined;
    return apiRuleToRuleDraft(rule);
  }, [ruleResponse?.data]);

  console.log(initialRuleDraft, ruleResponse?.data, "INIT DRAFT");

  if (isLoading) {
    return (
      <div className="min-h-[70vh] space-y-4 p-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-[480px] w-full max-w-3xl rounded-2xl" />
      </div>
    );
  }

  return (
    <section>
      <div className="flex items-center gap-4">
        <Link
          to="/dashboard/consumer-research/brand-moderator"
          className="flex size-9 items-center justify-center rounded-lg bg-muted text-foreground transition-colors hover:bg-muted/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          aria-label="Back to brand moderator"
        >
          <ChevronLeft className="size-5" />
        </Link>
        <h2 className="text-xl font-semibold">Configure Rule</h2>
      </div>
      <RuleBuilderPage key={id} ruleId={id} initialRuleDraft={initialRuleDraft} template={template} />
    </section>
  );
}
